import {ChangeDetectionStrategy, Component} from '@angular/core';
import {Router} from "@angular/router";
import {AuthService} from "../_services/auth.service";
import {ContentService} from "../_services/content.service";
import {SnackbarService} from "../_services/snackbar.service";
import {DynamicSettings} from "../_types/shared";
import {User} from "../_types/user";

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrl: './terms.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TermsComponent {
    user!: User;
    settings?: DynamicSettings;
    termsDynamic: string = '';

    constructor(private router: Router,
                private authService: AuthService,
                private contentService: ContentService,
                private snackbarService: SnackbarService) {
        this.authService.getUser().subscribe({
            next: r => {
                this.user = r;
            }
        })
        this.authService.getDynamicSettings().then((r): void => {
            this.settings = r;
        });
        this.contentService.getTerms().subscribe({
            next: r => {
                if (r && r.rendered) {
                    this.termsDynamic = r.rendered;
                }
            }, error: error => {
                console.error(error)
            }
        });
    }

    acceptTerms(): void {
        this.authService.acceptTerms().subscribe({
            next: r => {
                let user = {
                    has_completed_onboarding: 'true',
                }
                this.authService.patchUser(user)
                    .subscribe({
                        next: res => {
                            this.authService.setUser(res);
                            this.snackbarService.openSnackBar("Welcome to Virtual Memory Box! Don't forget to bookmark this page to access later.", 'success')

                            if (this.user.role.role_type == "young_person") {
                                // Will be child or adult or admin in prod
                                this.router.navigate(['/timeline']);
                            } else if (this.user.role.role_type == "admin") {
                                this.router.navigate(['/reporting']);
                            } else {
                                this.router.navigate(['/people']);
                            }
                        }, error: error => {
                            this.snackbarService.openSnackBar(error, 'error')
                            console.error(error)
                        }
                    });
            }, error: error => {
                this.snackbarService.openSnackBar(error, 'error')
                console.error(error)
            }
        });
    }

    navigateBack(): void {
        if (this.user.role.role_type == "young_person") {
            this.router.navigate(['/timeline']);
        } else if (this.user.role.role_type == "admin") {
            this.router.navigate(['/reporting']);
        } else {
            this.router.navigate(['/people']);
        }
    }
}
